class activeController{
  constructor(){
    'ngInject';
  }
}

export default activeController;


/** WEBPACK FOOTER **
 ** ./frontend/components/active/active.controller.js
 **/